<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :sortBy="sortBy"
      :showFields="showFields"
      :updateHideFields="updateHideFields"
      :pageMode="true"
      :showExpand="false"
      :inRowBtnRead="true"
      :rowClickRead="true"
      :filterSelects="filterSelects"
      :isMultiSelect="true"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/admin";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: ["name", "email", "roles"],
    updateHideFields: ["email"],
    liveSearching: true,
    sortBy: "sequence",
    filterSelects: [
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "user_factory_template_role",
        placeholder: "篩選角色",
      },
      {
        type: "switch-tabs",
        label: "",
        textKey: "name",
        modelName: "is_active",
        defaultValue: "1",
        items: [
          {
            value: "1",
            text: "啟用",
          },
          {
            value: "0",
            text: "停用",
          },
        ],
      },
      // {
      //   type: "belongsTo",
      //   label: "",
      //   textKey: "name",
      //   modelName: "user",
      //   placeholder: "選擇最後更新人",
      // },
    ],
  }),
};
</script>